module.exports = __webpack_public_path__ + "img/hdr_icon.88fe7e7f.png";